import simpleRestProvider from 'ra-data-simple-rest';
import { CreateParams, DataProvider, UpdateParams } from 'react-admin';
import { fetchJson } from '../fetchJson';
import transformModel from './transformModel';
import { apiRoutes } from '../apiRoutes';


export const createDataProvider = (): DataProvider => {

    const dataProvider: DataProvider = simpleRestProvider(apiRoutes.data, fetchJson, 'X-Total-Count');

    const wrappedDp = {

        ...dataProvider,
        update: async (resource: string, params: UpdateParams) => {
            const transform = transformModel[resource];
            if (transform) {
                params = await transform(params)
            }

            return dataProvider.update(resource, params);
        },
        create: async (resource: string, params: CreateParams) => {
            const transform = transformModel[resource];
            if (transform) {
                params = await transform(params)
            }

            return dataProvider.create(resource, params);
        },
    }

    return wrappedDp;
}



